$(document).ready(function(){
$('.mainmenumob-js').attr("tabindex", "0").on('keydown', function(event) {
    if (event.key === 'Enter') {
        $(this).click();
    }
});
    $('header nav ul li a').each(function() {
        // Check if the href attribute matches the current page's URL
        if (this.href === window.location.href) {
            $(this).attr('aria-current', 'page');
        }
    });
  
  jQuery('.options-color').attr('aria-label','color option');
  jQuery('.tt-collapse-content img, .product-list__item_image img').attr('alt','');

  jQuery('.lazyload, svg, i').attr('role','presentation');

jQuery('.tt-submenu a:first').attr('aria-expanded', 'false');


jQuery('.tt-submenu').each(function() {
    jQuery(this).find('a:first').attr('aria-haspopup', 'true');
  jQuery(this).find('a:first').attr('aria-expanded', 'false');
   

});


  
  
  jQuery('.hero-box__text strong').attr('role','heading');
  jQuery('.hero-box__text strong').attr('aria-level','2');

    jQuery('.tt-btn-zomm').attr('title','zoom');
jQuery('textarea[name="contact[body]"]').attr('aria-label', 'message');
jQuery('input[name="contact[name]"]').attr('aria-label', 'name');
jQuery('input[name="contact[email]"]').attr('aria-label', 'email');
jQuery('input[name="contact[phone]"]').attr('aria-label', 'phone');
jQuery('a[href="https://atlantavinylstore.com/cart"]').attr('aria-label', 'Shopping cart, open in new tab');
jQuery('a[href="https://affiliates.atlantavinylstore.com/"]').attr('aria-label', 'atlanta vinyl store cart, open in new tab');
jQuery('a[href="https://docs.google.com/forms/d/e/1FAIpQLScZaAdAuL0kPPRyUGtn0MG9VDfG63vDmyS3swsmoDM-hmfd1A/viewform"]').attr('aria-label', 'Google Document, open in new tab');

  jQuery('.minus-btn').attr('aria-label','minus');
 jQuery('.plus-btn').attr('aria-label','plus');
 jQuery('.svg-icon-delete').attr('aria-label','delete');

 jQuery('.tt-btn-quickview, .tt-btn-compare').attr('aria-hidden','true');
  

 
  jQuery('.sc-bQtKYq img').attr('alt','Silky Socks');
  
  jQuery('.tt-input-counter span').attr('tabindex','0');
  jQuery('.tt-input-counter span, .hero-box__button, .btn').attr('role','button');
  jQuery('.tt-input-counter input').attr('role','alert');
  jQuery('.tt-input-counter input').attr('aria-live','assertive');
  jQuery('.pf-header-item-wrapper').attr('role','button');
  jQuery('.pf-header-item-wrapper').attr('aria-expanded','false');
  jQuery('.pf-ifr').attr('title','Youtube video');
  jQuery('.tt-btn-quickview').attr('aria-label','quickview');
  jQuery('.tt-btn-compare').attr('aria-label','compare');
  jQuery('.pf-header-item-wrapper').attr('tabindex','0');
  jQuery('.featured-products__slider img').attr('alt',"");
  jQuery('.tt-account button').attr('title',"account");
  jQuery('.tt-account button').attr('aria-haspopup',"true");

  jQuery('.tt-search-input').attr('aria-label',"search field");
  jQuery('.tt-logo').attr('aria-label',"Atlanta homepage link");
  jQuery('.tt-btn-search').attr('title',"search button");
  jQuery('.close').attr('title',"close");
  jQuery('.collection-image-height img').attr('alt',"");
  jQuery('.tt-cart button').attr('title',"Cart");
  jQuery('.tt-cart button').attr('aria-haspopup',"true");

  
  jQuery('.tt-btn-close').attr('title',"close");
  jQuery('.tt-input-counter input').attr('aria-label',"counter");
  jQuery('.tt-quantity a').attr('aria-label',"quantity");
  jQuery('.scrollwidget_inputs input').attr('aria-label',"input area");
  jQuery('.featured-products__slider-item a').attr('aria-label',"Product");
  jQuery('.av-top-collections__collections-item a').attr('aria-label',"Top HTV collection");
  jQuery('.av-top-collections__collections-item a').attr('aria-label',"Top HTV collection");
  jQuery('.tt-cart button').attr('aria-expanded','false');
  setTimeout(function() { 
  jQuery('.tt-wrapper .active a').attr('aria-selected','true');
   }, 1000);
  document.querySelector('.tt-cart button').addEventListener('click', function() {
  const button = this.closest('.tt-cart button');
  const expanded = button.getAttribute('aria-expanded') === 'true';
  
  // Toggle the aria-expanded attribute
  button.setAttribute('aria-expanded', !expanded);
});

document.querySelectorAll('.pf-header-item-wrapper').forEach((item) => {
  item.addEventListener('click', toggleAriaExpanded);
  item.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      toggleAriaExpanded(event);
    }
  });
});

function toggleAriaExpanded(event) {
  const target = event.currentTarget;

  // Close all items first
  document.querySelectorAll('.pf-header-item-wrapper').forEach((item) => {
    item.setAttribute('aria-expanded', 'false');
  });

  // Toggle the clicked/selected item's aria-expanded
  target.setAttribute('aria-expanded', 'true');
}


  // Select all elements with the class `.tt-submenu`
document.querySelectorAll('.tt-submenu').forEach(submenu => {
    // Find the anchor (`<a>`) element within `.tt-submenu`
    const anchor = submenu.querySelector('a');

    // Proceed only if the anchor exists
    if (anchor) {
        // Create the button element
        const button = document.createElement('button');
        button.className = 'submenu-toggle';

        // Set initial button attributes and text
        button.textContent = `Submenu of ${anchor.textContent.trim()}`;
        button.setAttribute('aria-expanded', 'false');

        // Find the `.dropdown-menu` within the `.tt-submenu`
        const dropdownMenu = submenu.querySelector('.dropdown-menu');

        // Insert the button before the `.dropdown-menu`
        if (dropdownMenu) {
            submenu.insertBefore(button, dropdownMenu);
        }

        // Add a click event listener to the button
        button.addEventListener('click', () => {
            // Remove .active-menu from all other submenus
            document.querySelectorAll('.tt-submenu').forEach(otherSubmenu => {
                if (otherSubmenu !== submenu) {
                    otherSubmenu.classList.remove('active-menu');
                    const otherButton = otherSubmenu.querySelector('.submenu-toggle');
                    if (otherButton) {
                        otherButton.setAttribute('aria-expanded', 'false');
                    }
                }
            });

            // Toggle the `active-menu` class on the current `.tt-submenu`
            submenu.classList.toggle('active-menu');

            // Toggle the `aria-expanded` attribute on the button
            const isExpanded = button.getAttribute('aria-expanded') === 'true';
            button.setAttribute('aria-expanded', !isExpanded);
        });
    }
});

// Event listener to close the active menu when Esc key is pressed
document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        // Close all active submenus when Esc is pressed
        document.querySelectorAll('.active-menu').forEach(activeSubmenu => {
            activeSubmenu.classList.remove('active-menu');
            const button = activeSubmenu.querySelector('.submenu-toggle');
            if (button) {
                button.setAttribute('aria-expanded', 'false');
            }
        });
    }
});
// Handle click on sub-sub-toggle elements
document.querySelectorAll('.sub-sub-toggle').forEach(toggle => {
  toggle.addEventListener('click', function(event) {
    const parentLi = this.closest('li');

    // Toggle the active-submenu class on the parent li
    parentLi.classList.toggle('active-submenu');

    // Toggle aria-expanded attribute
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    this.setAttribute('aria-expanded', !isExpanded);

    // Close other active submenus
    document.querySelectorAll('.active-submenu').forEach(activeLi => {
      if (activeLi !== parentLi) {
        activeLi.classList.remove('active-submenu');
        // Reset aria-expanded for other toggles
        const activeToggle = activeLi.querySelector('.sub-sub-toggle');
        if (activeToggle) {
          activeToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });

    // Prevent event propagation to avoid closing other menus when clicking on the toggle itself
    event.stopPropagation();
  });
});

// Close active submenu on pressing Esc
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('.active-submenu').forEach(activeLi => {
      activeLi.classList.remove('active-submenu');
      // Reset aria-expanded for the toggle
      const activeToggle = activeLi.querySelector('.sub-sub-toggle');
      if (activeToggle) {
        activeToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }
});

jQuery(document).ready(function(){ 
    setTimeout(function(){ 
      //your code
      console.log("delay 2 sec");
        jQuery('.tt-btn-quickview').attr('aria-label','quickview');
  jQuery('.tt-btn-compare').attr('aria-label','compare');
        jQuery('.tt-btn-compare svg').attr('role','none');
  jQuery('.tt-quantity a').attr('aria-label',"quantity");
      jQuery('.kl-private-reset-css-Xuajs1 img').attr('alt',"");


     },
  2000); 
  
});

});
document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        document.querySelectorAll('.tt-input-counter span').forEach(span => {
            span.addEventListener('keydown', function(event) {
                if (event.key === 'Enter') {
                    // Trigger the click event when Enter is pressed
                    span.click();
                }
            });
        });
    }, 1000); // 1-second delay
});
document.addEventListener('DOMContentLoaded', () => {
    // Get the current URL
    const currentUrl = window.location.href;

    // Loop through all links in the custom collection menu
    document.querySelectorAll('.custom-collection-menu a').forEach(link => {
        if (link.href === currentUrl) {
            // Add aria-selected="true" to the matching link
            link.setAttribute('aria-selected', 'true');
        } else {
            // Ensure aria-selected is not set to true for non-matching links
            link.setAttribute('aria-selected', 'false');
        }
    });
});
